<template>
  <div>
    <cube-form :schema="schema" :model="form"></cube-form>
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        form: {
          jobType: 1,
          hurtPay: 10, //意外伤害-赔偿限额
          medicalPay: 0, // 意外医疗-赔偿限额
          hasSocial: true, // 是否有社保
          deductible: 0, // 年免赔额
          proportion: 1, // 赔付比例

          dayPay: 100, //住院日额津贴

          days: 0, //住院天数

          period: "一年",
          scheduleRating: 0, // 表定费率 总的
        },
        result: {
          a1: 0, // 意外伤害-表定费率（元/人）		 = 赔偿限额（万元/人）* 职业比例 * 10 *
          b1: 0, // 意外医疗-表定费率（元/人）		 =
          c1: 0, // 意外住院津贴-表定费率（元/人）		 =
        },

        // 189泰康团体意外伤害保险
        jobTypeFee: {
          "1": 1.56,
          "2": 2.16,
          "3": 3.24,
          "4": 5.55,
          "5": 6.91
        },

        // 191泰康附加意外住院津贴团体医疗保险B款团体医疗保险
        jobTypeFee230: {
          "1": 1,
          "2": 1.27,
          "3": 1.5,
          "4": 2.23,
          "5": 3.5
        },
        // 191泰康附加意外伤害B款团体医疗保险
        jobTypeFee191: {
          "1": 1,
          "2": 1.24,
          "3": 1.53,
          "4": 2.23,
          "5": 3.5
        },

        jobTypeMax: {
          "1": 100,
          "2": 100,
          "3": 60,
          "4": 60,
          "5": 40
        },
        // 年免赔额参数配置 230泰康附加意外伤害B款团体医疗保险
        deductibleList: {
          true: { // 有社保
            0: {
              0.8: 2.48,
              0.9: 2.78,
              1: 3.1,
            },
            50: {
              0.8: 2.35,
              0.9: 2.65,
              1: 2.94,
            },
            100: {
              0.8: 2.23,
              0.9: 2.52,
              1: 2.79,
            },
            200: {
              0.8: 1.78,
              0.9: 2.01,
              1: 2.23,
            }
          },
          false: { // 没有社保
            0: {
              0.8: 2.66,
              0.9: 2.98,
              1: 3.32,
            },
            50: {
              0.8: 2.52,
              0.9: 2.84,
              1: 3.15,
            },
            100: {
              0.8: 2.39,
              0.9: 2.7,
              1: 2.99,
            },
            200: {
              0.8: 1.91,
              0.9: 2.15,
              1: 2.39,
            }
          }
        },

        // 191泰康附加意外住院津贴团体医疗保险 费率 住院日额津贴
        hospitalizationFee: {
          0: {
            0: 0,
            2: 0,
            4: 0,
            6: 0
          },
          10: {
            0: 2.2,
            2: 1.9,
            4: 1.7,
            6: 1.4
          },
          20: {
            0: 4.3,
            2: 3.8,
            4: 3.4,
            6: 2.9
          },
          30: {
            0: 6.5,
            2: 5.8,
            4: 5,
            6: 4.3
          },
          40: {
            0: 8.6,
            2: 7.6,
            4: 6.8,
            6: 5.8
          },
          50: {
            0: 10.8,
            2: 9.6,
            4: 8.4,
            6: 7.2
          },
          60: {
            0: 13,
            2: 11.6,
            4: 10,
            6: 8.6
          },
          70: {
            0: 15.1,
            2: 13.4,
            4: 11.8,
            6: 10.1
          },
          80: {
            0: 17.2,
            2: 15.2,
            4: 13.6,
            6: 11.6
          },
          90: {
            0: 19.5,
            2: 17.4,
            4: 15,
            6: 12.9
          },
          100: {
            0: 21.7,
            2: 19.3,
            4: 16.7,
            6: 14.3
          },
          110: {
            0: 23.9,
            2: 21.2,
            4: 18.4,
            6: 15.7
          },
          120: {
            0: 26.1,
            2: 23.1,
            4: 20.1,
            6: 17.1
          },
          130: {
            0: 28.3,
            2: 25,
            4: 21.8,
            6: 18.5
          },
          140: {
            0: 30.5,
            2: 26.9,
            4: 23.5,
            6: 19.9
          },
          150: {
            0: 32.7,
            2: 28.8,
            4: 25.2,
            6: 21.3
          }
        },

        schema: {
          fields: [{
              type: 'select',
              modelKey: 'jobType',
              label: '职业类别',
              props: {
                options: [{
                    value: 1,
                    text: "1类"
                  },
                  {
                    value: 2,
                    text: "2类"
                  },
                  {
                    value: 3,
                    text: "3类"
                  },
                  {
                    value: 4,
                    text: "4类"
                  },
                  {
                    value: 5,
                    text: "5类"
                  }
                ],
              },
              events: {
                'change': this.onSubmit
              }
            },


            {
              type: 'select',
              modelKey: 'hurtPay',
              label: '意外伤害-赔偿限额',
              props: {
                options: [10, 20, 30, 40, 50, 60, 70, 80],
              },
              events: {
                'change': this.onSubmit
              }
            },



            {
              type: 'select',
              modelKey: 'medicalPay',
              label: '意外医疗-赔偿限额',
              props: {
                options: [{
                    value: 0,
                    text: "0"
                  }, {
                    value: 1,
                    text: "1"
                  },
                  {
                    value: 2,
                    text: "2"
                  },
                  {
                    value: 3,
                    text: "3"
                  },
                  {
                    value: 4,
                    text: "4"
                  },
                  {
                    value: 5,
                    text: "5"
                  }
                ],
              },
              events: {
                'change': this.onSubmit
              }
            },


            {
              type: 'select',
              modelKey: 'hasSocial',
              label: '是否有社保',
              props: {
                options: [{
                    value: true,
                    text: "有社保"
                  },
                  {
                    value: false,
                    text: "没有社保"
                  },
                ],
              },
              events: {
                'change': this.onSubmit
              }
            },

            {
              type: 'select',
              modelKey: 'deductible',
              label: '年免赔额',
              props: {
                options: [{
                    value: 0,
                    text: "0"
                  },
                  {
                    value: 50,
                    text: "50"
                  },
                  {
                    value: 100,
                    text: "100"
                  },
                  {
                    value: 200,
                    text: "200"
                  },
                ],

              },
              events: {
                'change': this.onSubmit
              }
            },

            {
              type: 'select',
              modelKey: 'proportion',
              label: '赔付比例',
              props: {
                options: [{
                    value: 0.8,
                    text: "80%"
                  },
                  {
                    value: 0.9,
                    text: "90%"
                  },
                  {
                    value: 1,
                    text: "100%"
                  },
                ],
              },
              events: {
                'change': this.onSubmit
              }
            },

            {
              type: 'select',
              modelKey: 'dayPay',
              label: '住院日额津贴',
              props: {
                // options: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150],
                options: [{
                    value: 0,
                    text: "0"
                  },
                  {
                    value: 50,
                    text: "50"
                  },
                  {
                    value: 100,
                    text: "100"
                  },
                  {
                    value: 150,
                    text: "150"
                  }
                ],
              },
              events: {
                'change': this.onSubmit
              }
            },

            {
              type: 'select',
              modelKey: 'days',
              label: '住院天数',
              props: {
                options: [{
                  value: 0,
                  text: "0天"
                }, {
                  value: 2,
                  text: "2天"
                }, {
                  value: 4,
                  text: "4天"
                }, {
                  value: 6,
                  text: "6天"
                }],
              },
              events: {
                'change': this.onSubmit
              }
            },

            {
              type: "input",
              modelKey: "period",
              label: '缴费期',
              props: {
                disabled: "disabled",
              }
            },

            {
              type: "input",
              modelKey: "scheduleRating",
              label: '表定费率',
              props: {
                disabled: "disabled",
              }
            },
          ]
        }
      }
    },
    methods: {
      onSubmit() {

        if (this.form.hurtPay > this.jobTypeMax[this.form.jobType]) {
          this.$createToast({
            time: 1000,
            txt: '超出当前职业类别限额，无法计算'
          }).show()

          return
        }

        if (this.form.medicalPay > 10) {
          this.$createToast({
            time: 1000,
            txt: '意外医疗赔偿限额超出限额，无法计算'
          }).show()
          return
        }

        // 重新计算各个价格
        this.result.a1 = new Number(this.form.hurtPay * 10 * this.jobTypeFee[this.form.jobType]).toFixed(2)


        this.result.b1 = this.deductibleList[this.form.hasSocial][this.form.deductible][this.form.proportion] * this.form
          .medicalPay * 10 * this.jobTypeFee230[this.form.jobType]

        this.result.b1 = new Number(this.result.b1).toFixed(2)


        this.result.c1 = this.hospitalizationFee[this.form.dayPay][this.form.days] * this.jobTypeFee191[this.form.jobType]
        this.result.c1 = new Number(this.result.c1).toFixed(2)

        this.form.scheduleRating = parseFloat(this.result.a1) + parseFloat(this.result.b1) + parseFloat(this.result.c1)

        this.form.scheduleRating = new Number(this.form.scheduleRating).toFixed(2)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  /*  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  } */

  .cube-form_standard .cube-form-label {
    width: 200px !important;
  }

  .cube-popup-content {
    top: -30% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue